angular.module('tradersyard').controller('topic-read-ctrl', [
    '$scope',
    '$flex',
    'graph-topic-factory',
    'graph-post-factory',
    'graph-like-factory',
    '$socket',
    function ($scope, $flex, $factory, $post, $like, $socket) {
        $scope.node = {};
        $scope.posts = [];
        $scope.page = 0;
        $scope.params = {
            page: 0,
            // order: 'asc'
        };

        $socket.on('comment:create', function (data) {
            if (data.place.name === 'post') {
                $scope.posts.forEach(function (node) {
                    if (parseInt(node.id) === parseInt(data.place.id)) {
                        ++node.comments;
                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    }
                });
            }
        });

        $socket.on('comment:delete', function (data) {
            if (data.place.name === 'post') {
                $scope.posts.forEach(function (node) {
                    if (parseInt(node.id) === parseInt(data.place.id)) {
                        --node.comments;
                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    }
                });
            }
        });

        $scope.query = function (next) {
            ++$scope.params.page;

            $post
                .entry('topic', $scope.node.id)
                .query({ params: $scope.params })
                .then(function (response) {
                    if (response.data.state === 0 && response.data.data.length > 0) {
                        $scope.posts = $scope.posts.concat(response.data.data);

                        $socket.emit(
                            'join:post',
                            response.data.data.map(function (item) {
                                return item.id;
                            })
                        );

                        if (next) next();
                    }
                });
        };

        $scope.like = function (item) {
            $like
                .entry('post', item.id)
                .like()
                .then(function (response) {
                    if (response.data.state === 0) {
                        item.im_like = true;
                        ++item.likes;
                    }
                });
        };

        $scope.unlike = function (item) {
            $like
                .entry('post', item.id)
                .unlike()
                .then(function (response) {
                    if (response.data.state === 0) {
                        item.im_like = false;
                        --item.likes;
                    }
                });
        };

        angular.extend($scope, $flex.data);
    },
]);
